const Button = ({
    icon: Icon,
    label,
    onClick,
    isForward,
    loading,
    disabled,
    className,
    type,
    iconClass,
}) => {
    return (
        <button
            type={type}
            disabled={disabled}
            className={`font-favorit z-10 font-normal w-fit text-[14px] leading-[16px] flex items-center h-[48px] py-[4px] px-[24px] w-auto rounded-[2.25rem] transition-all duration-300 ease-in-out group ${
                disabled
                    ? '!text-[#CCCCCC] pointer-events-none !bg-theme-header-bg'
                    : 'bg-theme-button-bg text-theme-black hover:bg-theme-orange hover:text-white'
            } ${className}`}
            onClick={onClick}>
            {loading ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
            ) : isForward ? (
                <>
                    {label}
                    {Icon && <Icon className={`ml-2 text-xl ${iconClass}`} />}
                </>
            ) : (
                <>
                    {Icon && <Icon className={`ml-2 text-xl ${iconClass}`} />}
                    {label}
                </>
            )}
        </button>
    );
};

export default Button;
